<template>
  <div>
    <div class="header">
      <div>
        <p>Scrubber 75</p>
        <p>{{ this.$t("scrubber75.scrubber75") }}</p>
      </div>
    </div>
    <div class="content">
      <video
        controls
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        x5-playsinline
        width="100%"
        src="https://enway-official.s3.ap-northeast-1.amazonaws.com/enway-video/2-4/S75.eecf4546.mp4"
      ></video>
    </div>
    <div class="footer">
      <img
        width="100%"
        src="../../assets/scrubber75/Specifications-Img-Vacuum-40-min-1.0591186c.png"
        alt=""
      />
      <p class="title">{{ this.$t("scrubber75.Scrubber75Specification") }}</p>
      <ul class="item-list">
        <li>
          <p>{{ this.$t("scrubber75.ProductSize") }}</p>
          <p>1370（L）* 962（W）* 1417（H）mm</p>
        </li>
        <li>
          <p>{{ this.$t("scrubber75.BatteryCapacity") }}</p>
          <p>Li-ion 240 Ah</p>
        </li>
        <li>
          <p>{{ this.$t("scrubber75.ContinuousUptime") }}</p>
          <p>4-6 h</p>
        </li>
        <li>
          <p>{{ this.$t("scrubber75.KiyoaraiWidth") }}</p>
          <p>750 mm</p>
        </li>
        <li>
          <p>{{ this.$t("scrubber75.SensorConfiguration") }}</p>
          <p>{{ this.$t("scrubber75.configuration") }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
.header {
  background: url("../../assets/scrubber75/Smart-Obstacle-Avoidance-D.-min.7b920454.png")
    no-repeat center;
  background-size: cover;
  height: 56vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 15.4667vw;
    margin-left: 19.2vw;
  }
  p {
    font-family: "Meiryooo";
    color: #ffffff;
  }
  p:first-child {
    font-size: 7.4667vw;
    font-weight: bold;
    line-height: 7.2vw;
  }
  p:last-child {
    font-size: 3.7333vw;
    font-weight: 500;
    line-height: 5.0667vw;
  }
}
.content {
  video {
    vertical-align: bottom;
  }
}
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    margin: 4vw 0;
  }
  .item-list {
    li {
      display: flex;
      margin: 0 9.0667vw;
      margin-bottom: 3.2vw;
      p {
        font-size: 3.2vw;
        font-family: "Meiryooo";
        line-height: 5.3333vw;
      }
      p:first-child {
        flex-shrink: 0;
        width: 23vw;
        color: #000;
        text-align: right;
        margin-right: 2.6667vw;
      }
      p:last-child {
        color: #0064e6;
      }
    }
    li:nth-child(2) {
      p:first-child {
        width: 28vw;
        margin-left: -5vw;
      }
    }
    li:last-child {
      margin-bottom: 10.6667vw;
    }
  }
}
</style>
